// plugins/pinia-sync.js
import { defineNuxtPlugin } from '#app'

let internalUpdate = false

export default defineNuxtPlugin(() => {
  const { setState } = useCartStore()
  // Listen for storage changes in other tabs
  window.addEventListener('storage', (event) => {
    if (event.key === 'cartStore' && !internalUpdate) {
      internalUpdate = true // Prevent loop

      // Update Pinia state from localStorage
      const cartStore = localStorage.getItem('cartStore')
      if (cartStore) {
        setState(JSON.parse(cartStore))
      }

      // Allow other updates
      setTimeout(() => {
        internalUpdate = false
      }, 100) // Adjust timeout if needed
    }
  })
})
